'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _card = require('antd/lib/card');

var _card2 = _interopRequireDefault(_card);

var _popconfirm = require('antd/lib/popconfirm');

var _popconfirm2 = _interopRequireDefault(_popconfirm);

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('antd/lib/card/style');

require('antd/lib/popconfirm/style');

require('antd/lib/button/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../');

var _style = require('./style.less');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _this.handleTableChange = function (_ref, filters, sorter) {
      var current = _ref.current,
          pageSize = _ref.pageSize;

      _this.setState({
        body: Object.assign({}, _this.state.body, {
          page: current,
          limit: pageSize,
          sorted: [{
            id: sorter.field,
            desc: sorter.order !== 'ascend'
          }]
        })
      }, function () {
        return _this.refresh();
      });
    };

    _this.showModal = function (modal) {
      _this.setState({
        visible: modal
      });
    };

    _this.handleCancel = function (callback) {
      var cb = typeof callback === 'function' ? callback : null;
      _this.setState({
        visible: true
      }, cb);
    };

    _this.handleOnSelect = function (selectedId) {
      _this.setState({
        selectedId: selectedId
      });
    };

    _this.afterSubmit = function () {
      _this.handleCancel(function () {
        _this.refresh();
      });
    };

    _this.refresh = function () {
      _this.props.getAllData({ body: _this.state.body, url: _this.props.url });
    };

    _this.filterHandler = function (data) {
      _this.setState({
        body: Object.assign({}, _this.state.body, {
          page: 1,
          filtered: data.formData
        })
      }, function () {
        return _this.refresh();
      });
    };

    _this.deleteData = function () {
      if (_this.state.selectedId) {
        var requestObject = { _id: _this.state.selectedId };
        if (_this.props.url) {
          requestObject = Object.assign({}, requestObject, { url: _this.props.url });
        }
        _this.props.deleteData(requestObject).then(function () {
          _this.refresh();
        });
      }
    };

    _this.state = {
      visible: false,
      selectedId: null,
      body: {
        limit: 20,
        page: 1,
        filtered: {},
        sorted: []
      }
    };
    return _this;
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refresh();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _card2.default,
        { bordered: false },
        _react2.default.createElement(
          'div',
          { className: _style2.default.tableList },
          this.props.filter && _react2.default.createElement(_.Form, {
            modelName: this.props.model,
            form: this.props.filterForm,
            fetchForm: this.props.fetchFilter,
            formIsLoading: this.props.filterIsLoading,
            clearButton: true,
            submitButtonName: 'Хайх',
            submitAction: this.filterHandler
          }),
          _react2.default.createElement(
            'div',
            { className: _style2.default.tableListOperator },
            this.props.actions.indexOf('create') !== -1 && _react2.default.createElement(
              _button2.default,
              {
                onClick: function onClick() {
                  return _this2.showModal(_this2.props.model + 'Create');
                },
                icon: 'plus',
                type: 'primary'
              },
              this.props.name + ' \u0431\u04AF\u0440\u0442\u0433\u044D\u0445'
            ),
            this.props.actions.indexOf('update') !== -1 && _react2.default.createElement(
              _button2.default,
              {
                onClick: function onClick() {
                  return _this2.showModal(_this2.props.model + 'Update');
                },
                icon: 'edit',
                type: 'primary',
                disabled: !this.state.selectedId
              },
              this.props.name + ' \u0437\u0430\u0441\u0430\u0445'
            ),
            this.props.actions.indexOf('delete') !== -1 && _react2.default.createElement(
              _popconfirm2.default,
              {
                title: '\u0422\u0430 \u0443\u0441\u0442\u0433\u0430\u0445\u0434\u0430\u0430 \u0438\u0442\u0433\u044D\u043B\u0442\u044D\u0439 \u0431\u0430\u0439\u043D\u0430 \u0443\u0443?',
                onConfirm: function onConfirm(e) {
                  return _this2.deleteData(e);
                },
                okText: '\u0422\u0438\u0439\u043C',
                cancelText: '\u04AE\u0433\u04AF\u0439'
              },
              _react2.default.createElement(
                _button2.default,
                {
                  icon: 'delete',
                  type: 'danger',
                  disabled: !this.state.selectedId
                },
                this.props.name + ' \u0443\u0441\u0442\u0433\u0430\u0445'
              )
            ),
            this.props.addonsArray.map(function (entry) {
              return _react2.default.createElement(
                _button2.default,
                {
                  onClick: function onClick() {
                    return _this2.showModal(entry.model + 'AddOnUpdate');
                  },
                  icon: 'edit',
                  type: 'primary',
                  key: entry.model,
                  disabled: !_this2.state.selectedId
                },
                entry.name + ' \u0437\u0430\u0441\u0430\u0445'
              );
            }),
            this.customAddons && this.customAddons.map(function (entry) {
              return entry();
            })
          ),
          _react2.default.createElement(_.StandardTable, {
            bordered: true,
            onSelect: this.handleOnSelect,
            onChange: this.handleTableChange,
            columns: this.props.headers,
            data: this.props.data,
            loading: this.props.isLoading,
            pagination: {
              total: this.props.total,
              current: this.state.body.page,
              pageSize: this.state.body.limit,
              showSizeChanger: true
            },
            scroll: { x: this.props.scroll }
          })
        ),
        _react2.default.createElement(_.ModalForm, {
          visible: this.state.visible === this.props.model + 'Create',
          modelName: this.props.model + '/post',
          submitAction: this.props.createData,
          onCancel: this.handleCancel,
          afterSubmit: this.afterSubmit,
          fetchForm: this.props.fetchForm,
          form: this.props.createForm,
          formIsLoading: this.props.formIsLoading,
          title: this.props.name + ' \u0431\u04AF\u0440\u0442\u0433\u044D\u0445',
          url: this.props.url,
          error: this.props.error,
          errorMessage: this.props.errorMessage
        }),
        _react2.default.createElement(_.ModalForm, {
          visible: this.state.visible === this.props.model + 'Update',
          modelName: this.props.model + '/put',
          submitAction: this.props.updateData,
          onCancel: this.handleCancel,
          afterSubmit: this.afterSubmit,
          fetchForm: this.props.fetchForm,
          form: this.props.updateForm,
          formIsLoading: this.props.formIsLoading,
          fetchData: this.props.getData,
          dataParams: { _id: this.state.selectedId },
          dataIsLoading: this.props.dataIsLoading,
          data: this.props.currentData,
          title: this.props.name + ' \u0437\u0430\u0441\u0430\u0445',
          url: this.props.url,
          error: this.props.error,
          errorMessage: this.props.errorMessage
        }),
        this.props.addonsArray.map(function (entry, index) {
          return _react2.default.createElement(_.ModalForm, {
            key: entry.model,
            visible: _this2.state.visible === entry.model + 'AddOnUpdate',
            onCancel: _this2.handleCancel,
            form: entry.form,
            formIsLoading: _this2.props.formIsLoading,
            fetchForm: _this2.props.fetchForm,
            data: entry.data,
            afterSubmit: _this2.afterSubmit,
            dataParams: { _id: _this2.state.selectedId },
            dataIsLoading: entry.isLoading,
            fetchData: _this2.props['addons' + index + 'get'],
            modelName: entry.model + '/put',
            submitAction: _this2.props['addons' + index + 'update'],
            title: entry.name + ' \u0437\u0430\u0441\u0430\u0445',
            url: _this2.props.url,
            error: entry.error,
            errorMessage: entry.errorMessage
          });
        })
      );
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  getAllData: _propTypes2.default.func.isRequired,
  headers: _propTypes2.default.array,
  data: _propTypes2.default.array,
  isLoading: _propTypes2.default.bool,
  total: _propTypes2.default.number,
  // end of list props

  model: _propTypes2.default.string.isRequired,
  filter: _propTypes2.default.bool,
  scroll: _propTypes2.default.number,
  addonsArray: _propTypes2.default.array,
  name: _propTypes2.default.string,
  url: _propTypes2.default.string,
  actions: _propTypes2.default.array,
  // customAddons: PropTypes.array,
  // end of component props

  fetchForm: _propTypes2.default.func.isRequired,
  formIsLoading: _propTypes2.default.bool,
  // end of form props

  fetchFilter: _propTypes2.default.func.isRequired,
  filterIsLoading: _propTypes2.default.bool,
  filterForm: _propTypes2.default.object,
  // end of filter props

  createData: _propTypes2.default.func.isRequired,
  updateData: _propTypes2.default.func.isRequired,
  deleteData: _propTypes2.default.func.isRequired,
  createForm: _propTypes2.default.object,
  updateForm: _propTypes2.default.object,
  getData: _propTypes2.default.func.isRequired,
  dataIsLoading: _propTypes2.default.bool,
  currentData: _propTypes2.default.object,
  // end of create update props

  error: _propTypes2.default.bool,
  errorMessage: _propTypes2.default.string
};

List.defaultProps = {
  headers: [],
  data: [],
  isLoading: false,
  total: 0,
  // end of list props

  filter: false,
  scroll: undefined,
  addonsArray: [],
  name: '',
  url: undefined,
  actions: [],
  // customAddons: [],
  // end of component props

  formIsLoading: false,
  // end of form props

  filterIsLoading: false,
  filterForm: {},
  // end of filter props

  createForm: {},
  updateForm: {},
  dataIsLoading: false,
  currentData: {},

  error: false,
  errorMessage: ''
};

exports.default = List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/List/list.js
// module id = 392
// module chunks = 0